import React, {Component} from 'react';
import AtividadesService from '../services/AtividadesService';
import UsuarioService from '../services/UsuarioService';
import GameService from '../services/GameService';
import AgendaService from '../services/AgendaService';
import { connect } from 'react-redux';


class Game extends Component {

    state = {
        codigo:null,
        codigoAtividade: null,
        action:null,
        game:null, 
        processando:false
    }

    componentDidMount() {
        if (this.state.processando) {
            return
        }
        this.setState({processando:true})
        const codigo = this.props.match.params.codigo
        const codigoAtividade = this.props.match.params.codigoAtividade
        const service = new GameService()
        const agendaService = new AgendaService()
        service.iniciarGame(codigo, codigoAtividade, (erro, action) => {
            this.setState({processando:false})
            if(action && action.dateFinished !== null){
                agendaService.atualizarAgenda(codigo, codigoAtividade, "GAME", null, null, (erro, sucesso) => {
                    if(erro){
                        alert( this.props.i18n.message("dinamica.erro.jaexecutada.mensagem", "Falha ao atualizar informações de atividade executadas, entre em contato com o suporte") )
                        return
                    }
                })
            }
            if (erro) {
                alert(JSON.stringify(erro))
                return
            }
           
            action.game.css = {background: action.game.theme.backgroundColor, color: action.game.theme.foregroundColor, borderTopLeftRadius:'30px', borderTopRightRadius:'30px'}

            this.cssHeader = {}
            this.cssHeader.color = action.game.theme.foregroundColor;

            this.setState({codigo:codigo, 
                           codigoAtividade:codigoAtividade,
                           action:action, 
                           game:action.game})
        })
    }

    jogar = () => {
        const atividadeservice = new AtividadesService()
        atividadeservice.finalizarAtividade(this.state.codigo, this.state.codigoAtividade, "GAME", {}, (erro, sucesso) => {
            if (erro) {
                alert( this.props.i18n.message("dinamica.erro.finalizar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde.") )
            } else if (sucesso) {
                const usuarioService = new UsuarioService()
                const url = this.state.game.url + "?action=" + this.state.action.actionId + "&tkn=" + usuarioService.token() + "&agenda=" + this.state.codigo
                localStorage.setItem('ultimoGame', url)
                localStorage.setItem('actionGame', this.state.codigoAtividade)
                window.location = url
            }
        })
    }

    render() {
        let i18n = this.props.i18n

        if (this.state.processando) {
            return <div>{ i18n.message("geral.aguarde", "Aguarde...") }</div>
        }
        const game = this.state.game
        if (! game) {
            return <div>{ i18n.message("dinamica.game.semjogo", "Sem jogo...") }</div>
        }
        return (
        <div>
            <div>
                <div className="card weex-card-interno">
                    <header className="card-header" style={game.css}>
                        <div className="card-header-title weex-card-header weex-card-header-atividade" style={this.cssHeader}>
                            {game.title ? (game.title) : (game.theme.name)}
                        </div>
                    </header>
                    <div className="conteudo-card-atividades borda-lateral-e-inferior">
                        <div className="card-content">
                            <div className="content weex-card-interno__content">
                                <div dangerouslySetInnerHTML={  {__html: game.presentation}   }></div>
                            </div>
                            <div style={{width:'100%', textAlign:'center'}}>
                                <button className="weex-button weex-botao-confirmacao" onClick={this.jogar}> {i18n.message("dinamica.game.jogar", "JOGAR")} </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>)
    }
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(Game)